import { setMvk, setMvkLoadingError } from '../../../shared/actions/mvk';
import { fetchGetNewbuildingPolygons } from '../../../shared/repositories/newbuilding-mvk/v2/get-newbuilding-polygons';
import { TThunkAction } from '../../../shared/types/redux/thunk';
import { getUTMDataFromQueryString } from '../../utils/getUTMDataFromQueryString';

export function loadMVK(): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }) => {
    const {
      newbuilding: { id: newbuildingId },
    } = getState();

    try {
      const { response, statusCode } = await fetchGetNewbuildingPolygons({
        httpApi,
        parameters: {
          newbuildingId,
          ...getUTMDataFromQueryString(),
        },
        config: {
          ecnhancersConfig: {
            timeout: 7000,
          },
        },
      });

      if (statusCode !== 200 || 'errors' in response) {
        throw new Error(response.message);
      }

      dispatch(setMvk(response));
    } catch (error) {
      logger.warning('[Degradation] Failed to load MVK', {
        newbuildingId,
        domain: 'loadMvk',
        message: error.message,
      });

      dispatch(setMvkLoadingError(true));
    }
  };
}
